import { call, all } from 'redux-saga/effects';
import { onListTemplatesStart } from './list-templates';
import { onCreateTemplateStart } from './create-template';

export default function* onTemplatesAction() {
  yield all([call(onListTemplatesStart), call(onCreateTemplateStart)]);
}
